import { render, staticRenderFns } from "./DetailTicketReservation.vue?vue&type=template&id=7eef8c4f&scoped=true"
import script from "./DetailTicketReservation.vue?vue&type=script&lang=js"
export * from "./DetailTicketReservation.vue?vue&type=script&lang=js"
import style0 from "./DetailTicketReservation.vue?vue&type=style&index=0&id=7eef8c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eef8c4f",
  null
  
)

export default component.exports